// removed by extract-text-webpack-plugin
module.exports = {"Black":"#333D47","sizeXL":"20px","recipeList":"G65f560","recipeListText":"G59a6d9","variantsTitle":"G3655d9","item":"Gea9a90"};